import { render, staticRenderFns } from "./CustomerDetail-info.vue?vue&type=template&id=03ae08e0&scoped=true"
import script from "./CustomerDetail-info.vue?vue&type=script&lang=js"
export * from "./CustomerDetail-info.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail-info.vue?vue&type=style&index=0&id=03ae08e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae08e0",
  null
  
)

export default component.exports